import React from 'react';
import PropTypes from 'prop-types';
import { Slide } from '@sp/ui/layout/Swiper';
import mobileImage from 'assets/images/intro/3/Splash3-mobile.jpg';
import desktopImage from 'assets/images/intro/3/Splash3-desktop.jpg';
import withTranslation from 'decorators/i18n';

const Splash3 = ({ i18n }) => (
  <Slide
    heading={i18n.t('onboarding|splash3Heading')}
    testID="introSlideMoney"
    description={i18n.t('onboarding|splash3Description')}
    sources={{
      mobile: mobileImage,
      desktop: desktopImage,
    }}
    textOnly
  />
);

Splash3.propTypes = {
  i18n: PropTypes.object.isRequired,
};

Splash3.defaultProps = {
  backButton: undefined,
  hasNotificationMargin: false,
};

export default withTranslation(['onboarding'])(Splash3);
